import styled from 'styled-components';
import ThemeHelper from '../../themes/theme-helper';
import {
  flexbox,
  justifyContent,
  alignItems,
  inlineFlexbox,
  flexGrow
} from '../../styles/helpers/flexbox';

const StudentListWrapper = styled.div((props) => {
  const { typography } = ThemeHelper.getTheme(props);

  return `
    min-width: 260px;
    max-width: 260px;
    font-family: ${typography.family};
    font-size: 14px;
    left: 0;
    background-color: white;
    overflow: hidden;
    border-bottom: 15px solid transparent;
`;
});

const ListItemContainer = styled.div((props) => {
  const { colours } = ThemeHelper.getTheme(props);

  return `${flexbox()};
    ${justifyContent('space-between')};
    ${alignItems('center')};
    box-sizing: border-box;
    border: 1px solid ${colours.grey[400]};
    border-left: none;
    border-top: none;
    height: 33px;
    background-color: white;
  `;
});

const ListItem = styled.div((props) => {
  const { palette, colours } = ThemeHelper.getTheme(props);
  const { showProgress } = props;

  return `
    ${flexbox()};
    ${justifyContent('space-between')};
    padding: 5px;
    font-weight: 400;
    color: ${palette.primary.dark};
    width: ${props.showCheckbox === true ? '80%' : '100%'};
    border-right: ${props.showCheckbox === true ? `2px solid ${colours.grey[400]}` : ''};
    height: 22px;
    align-items: center;
    cursor: ${showProgress ? 'pointer' : 'initial'};

    .fullName {
      padding-left: 5px;
      line-height: 12px;
      width: inherit;
    }
  `;
});

const StudentProgress = styled.span(props => `
  align-self: baseline;
  width: 36px;
  height: 100%;
  position: relative;
  div[class^="svgIconComponent"] {
    width: 100%;
    svg {
      width: 100%;
      height: 25px;
    }
  }
  &::before,
  &::after {
    position: absolute;
    top: 0;
  }
  &::before {
    content: '${props.percent}%';
    left: 0;
    color: white;
    font-size: 12px;
    width: 100%;
    height: 100%;
    ${flexbox()}
    ${justifyContent('center')}
    ${alignItems('center')}
  }
  ${props.showDot ?
    `&::after {
      content: '';
      right: 0;
      width: 7px;
      height: 7px;
      border-radius: 100%;
      background-color: orangered;
      transform: translate(30%, -30%);
    }` :
    ''}
`);

const HeaderContainer = styled(ListItemContainer)((props) => {
  const { colours } = ThemeHelper.getTheme(props);

  return `
  height: 48px;
  border: 1px solid ${colours.grey[400]};
  border-left: none;
  background-color: white;
  position: sticky;
  top: 0;
  max-width: 262px;
  width: 260px;
  z-index: 1;
  `;
});

const StudentHeader = styled.div((props) => {
  const { colours } = ThemeHelper.getTheme(props);

  return `
    ${flexbox()};
    ${alignItems('center')};
    ${justifyContent('space-between')};
    font-weight: 600;
    padding: 0px 5px;
    border-right: 2px solid ${colours.grey[400]};
    user-select: none;
    height: 47px;
    width: 80%;

    .title {
        ${inlineFlexbox()};
        ${justifyContent('flex-start')};
        font-size: 12px;
        font-weight: 400;
        width: 110px;
        padding: 5px;
        max-height: 10px;
        cursor: pointer;

        .label {
          padding-left: 5px;
        }
    }

    div:nth-child(1) {
      height: 10px;
    }

    .activities {
        ${inlineFlexbox()};
        ${justifyContent('flex-end')};
        width: 100px;
        text-align: center;
        font-size: 12px;
        font-weight: 400;
        padding: 5px;
        max-height: 10px;
        cursor: default;
    }
`;
});

const SvgWrapper = styled.div(props => `
    path {
      fill: ${props.status ? '#1981c4' : 'black'} !important;
    }
  `
);

const LoaderWrapper = styled.div`
    ${flexbox()}
    ${justifyContent('center')}
    ${alignItems('center')}

    flex: 1;
    height: 100%;
`;

const StudentListItemWrapper = styled.div`

    margin-top: 0.01px;
`;

const CheckboxWrapper = styled.span((props) => {
  const { colours } = ThemeHelper.getTheme(props);

  return `
    ${flexbox()};
    ${justifyContent('center')};
    ${alignItems('center')};

    width: 40px;
    height: 100%;
    background-color: ${colours.grey[200]};
`;
});

const CheckboxHeader = styled.div`
  ${flexGrow(1)}

  margin-top: 5px;

  svg {
    height: 25px;
    width: 25px;
  }

  button {
    background-color: transparent;
    border: 0;
  }
`;

const ReviewIcon = styled.span`

  width: 24px;
  display: inline-block;
  margin-left: 10px;
`;

const ContextWrapper = styled.div`
  ${flexbox()}
  ${alignItems('center')}

  height: 35px;
`;

export {
  StudentListWrapper,
  StudentHeader,
  ListItem,
  LoaderWrapper,
  ListItemContainer,
  HeaderContainer,
  SvgWrapper,
  StudentListItemWrapper,
  CheckboxWrapper,
  CheckboxHeader,
  ReviewIcon,
  ContextWrapper,
  StudentProgress
};
